import React, { useEffect, useMemo, useState } from 'react'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import Switch from '../../components/Inputs/Switch'
import InputNumber from '../../components/Inputs/InputNumber'
import { useForm } from 'react-hook-form'
import { ISuscription } from './Suscriptions'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import { IoAddSharp } from 'react-icons/io5'
import { FiTrash2 } from 'react-icons/fi'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import CargaImage from '../../assets/images/CARGA.png'

const SuscriptionForm = ({ onCancel, onSubmit, isLoadingForm, defaultValues }: { onCancel: () => void; onSubmit: (values: any) => void; isLoadingForm: boolean; defaultValues: ISuscription }) => {
  const [activeState, setActiveState] = useState<boolean>(defaultValues?.active !== undefined ? defaultValues.active : true)
  const [itemsLists, setItemLists] = useState<any[]>(defaultValues?.items || [])
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [amount, setAmount] = useState<any>(0)

  const { addAlert } = useSnackBars()

  const form = useForm({
    defaultValues: {
      frequency: defaultValues?.frequency || 'monthly',
      total: defaultValues?.total || 0,
      description: defaultValues?.description || '',
      active: defaultValues?.active !== undefined ? defaultValues.active : true,
      emailTitle: defaultValues?.emailTitle || '',
      emailBody: defaultValues?.emailBody || '',
      c2pEnabled: defaultValues?.c2PEnabled || true,
      ivaType: defaultValues?.ivaType || 'GENERAL',
    },
  })

  const { setValue } = form

  const frequencyOptions = [
    { value: 'monthly', text: 'Mensual' },
    { value: 'weekly', text: 'Semanal' },
    { value: 'biweekly', text: 'Quincenal' },
    { value: 'quarterly', text: 'Trimestral' },
    { value: 'annual', text: 'Anual' },
  ]

  const ivaTypeOptions = [
    { value: 'GENERAL', text: 'General' },
    { value: 'REDUCED', text: 'Reducido' },
    { value: 'EXEMPT', text: 'Exento' },
  ]

  // Memoizar los defaultValues para evitar crear nuevos objetos en cada render
  const frequencyDefaultValue = useMemo(
    () => frequencyOptions.find(v => v?.value === defaultValues?.frequency) || frequencyOptions[0],
    [defaultValues?.frequency]
  )

  const ivaTypeDefaultValue = useMemo(
    () => ivaTypeOptions.find(v => v?.value === defaultValues?.ivaType) || ivaTypeOptions[0],
    [defaultValues?.ivaType]
  )

  useEffect(() => {
    console.log('🔄 [SuscriptionForm] useEffect ejecutado')
    console.log('📦 [SuscriptionForm] defaultValues:', defaultValues)
    console.log('📦 [SuscriptionForm] defaultValues?.items:', defaultValues?.items)
    console.log('📦 [SuscriptionForm] itemsLists actual:', itemsLists)

    if (defaultValues?.active !== undefined) {
      setActiveState(defaultValues.active)
      setValue('active', defaultValues.active)
    }

    // Establecer frecuencia y tipo de IVA usando los valores memoizados
    setValue('frequency', frequencyDefaultValue)
    setValue('ivaType', ivaTypeDefaultValue)

    if (defaultValues?.items && defaultValues?.items.length > 0) {
      console.log('✅ [SuscriptionForm] Seteando items desde defaultValues (tiene items)')
      setItemLists(defaultValues.items)
    } else if (!defaultValues?.id) {
      // Solo resetear a vacío si estamos creando (no editando)
      console.log('🆕 [SuscriptionForm] Modo creación - reseteando items a []')
      setItemLists([])
    } else {
      console.log('⚠️  [SuscriptionForm] Modo edición sin items - NO reseteando itemsLists')
    }
    // Solo ejecutar este efecto cuando se abre el modal (cuando defaultValues.id cambia)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues?.id, setValue])

  const onSubmitForm = (values): void => {
    console.log('📤 [SuscriptionForm] ============ SUBMIT INICIADO ============')
    console.log('📤 [SuscriptionForm] values recibidos del form:', values)
    console.log('📤 [SuscriptionForm] itemsLists actual en submit:', itemsLists)
    console.log('📤 [SuscriptionForm] itemsLists.length:', itemsLists.length)

    // Siempre enviar strings vacíos para emailTitle y emailBody
    // Usar activeState del estado local en lugar del valor del formulario
    const mappedItems = itemsLists.map(item => {
      const itemType = item.type === 'product' || item.type === 'service'
        ? item.type
        : (Object.keys(item).length <= 6 ? 'service' : 'product')

      const mappedItem: any = {
        id: item.id,
        type: itemType,
        amount: item.amount,
      }

      // Si es producto, agregar category
      if (itemType === 'product' && item.category) {
        mappedItem.category = {
          id: item.category.id
        }
      }

      return mappedItem
    })
    console.log('📤 [SuscriptionForm] mappedItems después del map:', mappedItems)
    console.log('📤 [SuscriptionForm] mappedItems.length:', mappedItems.length)

    const finalPayload = {
      description: values.description,
      frequency: values.frequency?.value || values.frequency,
      ivaType: values.ivaType?.value || values.ivaType,
      total: values.total,
      active: activeState,
      discount: '$ 0,00',
      emailTitle: '',
      emailBody: '',
      c2pEnabled: true,
      items: mappedItems,
    }
    console.log('📤 [SuscriptionForm] PAYLOAD FINAL que se enviará al padre:', finalPayload)
    console.log('📤 [SuscriptionForm] ============================================')

    onSubmit(finalPayload)
  }

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-4`}
        onSubmit={(values) => onSubmitForm(values)}
      >
        {/* Header */}
        <div className="col-span-12" style={{ fontWeight: 500, fontSize: '18px' }}>
          {defaultValues?.id ? 'Editar suscripción' : 'Creación de suscripción'}
        </div>

        {/* Basic Information Section */}
        <div className="col-span-12" style={{ fontWeight: 500, marginTop: '10px' }}>
          Información Básica
        </div>

        <FormItem
          name="description"
          classes="col-span-12"
          defaultValue=""
          rules={{
            required: 'El nombre es requerido',
            maxLength: { value: 200, message: 'Máximo 200 caracteres' },
          }}
        >
          <InputText
            label="Nombre de la Suscripción"
            maxLength={200}
          />
        </FormItem>

        <FormItem
          name="frequency"
          classes="col-span-12"
          defaultValue={frequencyDefaultValue}
          rules={{
            required: 'La frecuencia es requerida',
          }}
        >
          <SelectOfCategories
            label="Frecuencia de Pago"
            placeholder="Seleccionar frecuencia"
            options={frequencyOptions}
          />
        </FormItem>

        {/* Pricing Section */}
        <div className="col-span-12" style={{ fontWeight: 500, marginTop: '10px' }}>
          Configuración de Precios
        </div>

        <FormItem
          name="total"
          classes="col-span-6"
          defaultValue={120.0}
          rules={{
            required: 'El total es requerido',
            min: { value: 0, message: 'El total debe ser mayor a 0' },
          }}
        >
          <CurrencyInput
            addDecimals={true}
            label="Precio"
            mask="$ num"
          />
        </FormItem>

        <FormItem
          name="ivaType"
          classes="col-span-6"
          defaultValue={ivaTypeDefaultValue}
          rules={{
            required: 'El tipo de IVA es requerido',
          }}
        >
          <SelectOfCategories
            label="Tipo de IVA"
            placeholder="Seleccionar tipo de IVA"
            options={ivaTypeOptions}
          />
        </FormItem>

        {/* Email Configuration Section */}
        {/* <div className="col-span-12" style={{ fontWeight: 500, marginTop: '10px' }}>
          Configuración de Email
        </div>

        <FormItem
          name="emailTitle"
          classes="col-span-12"
          defaultValue=""
          rules={{
            required: 'El título del email es requerido',
            maxLength: { value: 100, message: 'Máximo 100 caracteres' },
          }}
        >
          <InputText
            label="Título del Email"
            maxLength={100}
          />
        </FormItem>

        <FormItem
          name="emailBody"
          classes="col-span-12"
          defaultValue=""
          rules={{
            required: 'El cuerpo del email es requerido',
            maxLength: { value: 500, message: 'Máximo 500 caracteres' },
          }}
        >
          <TextArea
            label="Cuerpo del Email"
        maxLength={500}
            rows={4}
          />
        </FormItem> */}

        {/* Articles/Services Section */}
        <div className="col-span-12" style={{ fontWeight: 500, marginTop: '20px' }}>
          Artículos y Servicios
        </div>

        <div className="col-span-12">
          <div className="mt-5">
            {itemsLists?.map((item, index) => (
              <div
                className="bg-gray-100 dark:bg-gray-800 rounded-lg my-4 p-2 flex justify-between items-center"
                key={index}
              >
                <div className="truncate">
                  <h1 className="text-sm ml-3 dark:text-white">{item.name}</h1>
                  <h1 className="text-sm ml-3 dark:text-white">
                    Cantidad: {item.amount}
                  </h1>
                </div>

                <Button
                  classes="border-none"
                  onClick={() => {
                    setItemLists(itemsLists.filter((x, i) => i !== index))
                  }}
                  htmlType="button"
                >
                  <FiTrash2 size={20} color="red" />
                </Button>
              </div>
            ))}
          </div>

          {itemsLists.length === 0 && (
            <div className="mt-5 flex flex-col items-center">
              <img
                src={CargaImage}
                alt="zerux"
                style={{ height: 120, width: 200 }}
              />

              <label
                style={{
                  color: '#919191',
                  width: '70%',
                  textAlign: 'center',
                  marginTop: -1,
                  fontSize: 15,
                }}
              >
                Asigna artículos / servicios
              </label>
            </div>
          )}

          <div className="flex flex-row justify-between items-center gap-2 mt-4">
            <div style={{ width: '60%', position: 'relative' }}>
              <RawAutoComplete
                label="Artículo / Servicio"
                url={`inventory/item/simple-search`}
                bodyGet={'items'}
                queryParam={'param'}
                selectedValue={selectedItem}
                setSelectedValue={(value) => {
                  setSelectedItem(value)
                }}
                type="multiple"
                multipleValues={[
                  { url: 'inventory/item/simple-search', bodyGet: 'items', queryParam: 'param' },
                  { url: 'service', bodyGet: 'services', queryParam: 'name' }
                ]}
              />
            </div>

            <div style={{ width: '30%' }}>
              <InputNumber
                small
                label="Cantidad"
                onChange={(value) => {
                  setAmount(value)
                }}
                value={amount}
              />
            </div>

            <div className="mt-3">
              <div
                className="bg-primary cursor-pointer hover:bg-primary-dark transition"
                style={{ padding: 5, borderRadius: 8 }}
                onClick={() => {
                  console.log('➕ [SuscriptionForm] Click en agregar item')
                  console.log('➕ [SuscriptionForm] itemsLists antes de agregar:', itemsLists)
                  console.log('➕ [SuscriptionForm] amount:', amount)
                  console.log('➕ [SuscriptionForm] selectedItem:', selectedItem)

                  if (amount === 0 || !amount) {
                    addAlert({
                      message: 'La cantidad debe ser mayor a cero',
                      status: 'error',
                    })
                    return
                  }

                  if (!selectedItem) {
                    addAlert({
                      message: 'El artículo / servicio es requerido',
                      status: 'error',
                    })
                    return
                  }

                  console.log('➕ [SuscriptionForm] selectedItem keys:', Object.keys(selectedItem))

                  // Determinar el tipo correcto: si viene de servicio (menos propiedades) o de inventario (más propiedades)
                  const itemType = Object.keys(selectedItem).length <= 6 ? 'service' : 'product'
                  console.log('➕ [SuscriptionForm] determined itemType:', itemType)

                  const newItem = { ...selectedItem, amount, type: itemType }
                  console.log('➕ [SuscriptionForm] newItem construido:', newItem)

                  setItemLists((prevState) => {
                    const newList = [...prevState, newItem]
                    console.log('➕ [SuscriptionForm] NEW itemsLists después de agregar:', newList)
                    return newList
                  })
                  setAmount(0)
                  setSelectedItem(null)
                }}
              >
                <IoAddSharp color="white" size={20} />
              </div>
            </div>
          </div>
        </div>

        {/* Settings Section */}
        <div className="col-span-12" style={{ fontWeight: 500, marginTop: '20px' }}>
          Configuración
        </div>

        <div className="col-span-12 flex flex-row gap-6">
          <div className="flex items-center">
            <Switch
              label={activeState ? "Suscripción Habilitada" : "Suscripción Inhabilitada"}
              value={activeState}
              forForm={true}
              onChange={(value) => {
                setActiveState(value)
                setValue('active', value)
              }}
            />
          </div>
        </div>

        <div
          style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
          className="col-span-12 mt-3"
        ></div>

        {/* Action Buttons */}
        <div className="col-span-12 h-full flex flex-row mt-4">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={onCancel} disabled={isLoadingForm}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit" disabled={isLoadingForm} loading={isLoadingForm}>
              {defaultValues?.id ? 'Guardar cambios' : 'Crear Suscripción'}
            </Button>
          </div>
        </div>

      </Form>
    </>
  )
}

export default SuscriptionForm
